<!-- 首页//设备状态统计  -->
<template>
  <div class="box">
    <Title :text="home.EquipmentStatistics.Title[0]" :engText="home.EquipmentStatistics.Title[1]"></Title>
    <div class="content">
      <div class="left">
        <div class="echarts-content">
          <chart-block ref="echart"></chart-block>
        </div>
      </div>
      <div class="right">
        <div class="li li1">
			<div class="a a1"></div>
			<div class="a a2">
				<div class="b b1">
					<div class="fs14">电表(台)</div>
					<div class="scaleLeft-5">在线数：<span>250</span></div>
				</div>
				<div class="b b2">
					<div class="fs14">总数：<span>500</span></div>
					<div class="scaleRight-5">离线数：<span>250</span></div>
				</div>
			</div>
		</div>
        <div class="li li2">
			<div class="a a1"></div>
			<div class="a a2">
				<div class="b b1">
					<div class="fs14">水表(台)</div>
					<div class="scaleLeft-5">在线数：<span>250</span></div>
				</div>
				<div class="b b2">
					<div class="fs14">总数：<span>500</span></div>
					<div class="scaleRight-5">离线数：<span>250</span></div>
				</div>
			</div>
		</div>
        <div class="li li3">
			<div class="a a1"></div>
			<div class="a a2">
				<div class="b b1">
					<div class="fs14">电气火灾(台)</div>
					<div class="scaleLeft-5">在线数：<span>250</span></div>
				</div>
				<div class="b b2">
					<div class="fs14">总数：<span>500</span></div>
					<div class="scaleRight-5">离线数：<span>250</span></div>
				</div>
			</div>
		</div>
        <div class="li li4">
			<div class="a a1"></div>
			<div class="a a2">
				<div class="b b1">
					<div class="fs14">空调(台)</div>
					<div class="scaleLeft-5">在线数：<span>250</span></div>
				</div>
				<div class="b b2">
					<div class="fs14">总数：<span>500</span></div>
					<div class="scaleRight-5">离线数：<span>250</span></div>
				</div>
			</div>
		</div>
        <div class="li li5">
			<div class="a a1"></div>
			<div class="a a2">
				<div class="b b1">
					<div class="fs14">视频监控(台)</div>
					<div class="scaleLeft-5">在线数：<span>250</span></div>
				</div>
				<div class="b b2">
					<div class="fs14">总数：<span>500</span></div>
					<div class="scaleRight-5">离线数：<span>250</span></div>
				</div>
			</div>
		</div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '../../components/title/index.vue';
import { mapState,mapActions } from 'pinia' //引入映射函数
import useStore from '@/store/index' //引入store
export default {
  components: {
    Title,
  },
  computed:{
    ...mapState(useStore,['home']) 
  },
  mounted () {
    this.$refs.echart.setOption(this.home.EquipmentStatistics.Option);
  }
}
</script>

<style scoped>
.box{
   width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.content{
  flex: 1;
  overflow: hidden;
  display: flex;
  /* background-color: red; */
}
.content .left{
  flex: 1;
  display: flex;
}
.content .right{
	flex: 1;
	display: flex;
	justify-content: space-between;
	flex-direction: column;
	margin-top: 10px;
}
.content .right .li{
  /* flex:1; */
  display: flex;
}
.content .right .li .a1{
	margin:6px 4px 0px 0px;
}
.content .right .li1 .a1{
	width: 8px;
	height: 8px;
	background: #ffb400;
}
.content .right .li2 .a1{
	width: 8px;
	height: 8px;
	background: #36ddff;
}
.content .right .li3 .a1{
	width: 8px;
	height: 8px;
	background: #0485c0;
}
.content .right .li4 .a1{
	width: 8px;
	height: 8px;
	background: #36ffc4;
}
.content .right .li5 .a1{
	width: 8px;
	height: 8px;
	background: #488dff;
}
.content .right .li .a2{
	flex: 1;
	display: flex;
	justify-content: space-between;
	height: 100%;
	font-size: 12px
}
.content .right .li .a2 .b2{
	display: flex;
	flex-direction: column;
	align-items: flex-end;
}
.content .right .li .a2 .b span{
	color: white;
}
.scaleRight-5{
	transform: scale(.8) translateX(7px);
    display: inline-block;
}
.scaleLeft-5{
	transform: scale(.8) translateX(-7px);
    display: inline-block;
}
.fs14{
	font-size: 14px;
}
</style>